var map = {
	"./ava_Youtube.svg": 4188,
	"./galeria_Youtube.svg": 2253,
	"./jamh_Youtube.svg": 3210,
	"./kbmo_Youtube.svg": 9429,
	"./ktkh_Youtube.svg": 8238,
	"./pmh_Youtube.svg": 6889,
	"./szimh_Youtube.svg": 4809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6968;